import { useSiteConfig } from "@context/siteConfig";
import { useTranslations } from "@context/translations";
import clsx from "clsx";
import { useEffect, useState } from "react";
import styles from "./ContactUs.module.scss";

interface ContactUsProps {
  isDarkTheme?: boolean;
}

const ContactUs: React.FC<ContactUsProps> = ({ isDarkTheme }) => {
  const translate = useTranslations();
  const { isRtl } = useSiteConfig();

  const getScreenWidth = (): number => {
    return window.innerWidth;
  };

  const [screenWidth, setScreenWidth] = useState<number>(null);

  useEffect(() => setScreenWidth(getScreenWidth()), []);

  return (
    <div
      className={clsx(
        styles.container,
        isRtl && styles.rtl,
        isDarkTheme && styles.dark
      )}
    >
      <div className={styles.heroContainer}>
        <div className={styles.heroImage} />
        <div className={styles.titleContainer}>
          <div className={styles.title}>{translate("contact_us")}</div>
          <div className={styles.text}>{translate("dont_be_shy")}</div>
        </div>
      </div>

      <div className={styles.main}>
        <div className={styles.contentContainer}>
          <div>
            <div className={styles.header}>{translate("get_in_touch")}</div>
            <div className={styles.text}>{translate("hear_from_you")}</div>
          </div>
          <div>
            <div className={styles.header}>{translate("reach_us")}</div>
            <div className={styles.text}>
              {translate("email_us")}
              <div>
                <a href="mailto:contact@shopcash.com">
                  {translate("contact_us_email")}
                </a>
              </div>
            </div>
          </div>
        </div>
        {screenWidth >= 768 ? (
          <img
            src="https://assets.wego.com/image/upload/v1605508895/web/shopcash/illustration-contact-us.png"
            alt="email-us-image"
          />
        ) : null}
      </div>
    </div>
  );
};

export default ContactUs;
